"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="225203" className="flex flex-col gap-6 mt-12 px-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-8 w-48 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-6 mt-12 px-4">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-3xl font-default font-medium text-foreground hover:text-primary-foreground transition-colors" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          setIsMobileMenuOpen(false);
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            setIsMobileMenuOpen(false);
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="navigation-f2s" className={`sticky top-0 z-50 w-full transition-all duration-300 border-b text-foreground ${isScrolled ? "bg-background/80 backdrop-blur-xl border-border shadow-sm" : "bg-background border-transparent"}`}>
      <div className="container mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        {}
        <div className="flex-1 flex justify-start">
          <SafeHydrate><Drawer direction="left" open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
            <DrawerTrigger asChild>
              <Button variant="ghost" size="icon" className="text-foreground hover:bg-accent/50" aria-label="Ouvrir le menu">
                <Menu className="size-6" />
              </Button>
            </DrawerTrigger>
            <DrawerContent className="w-[85vw] sm:w-[400px] h-full rounded-none border-r border-border bg-background">
              <DrawerHeader className="flex items-center justify-between border-b border-border/50 pb-4">
                <DrawerTitle className="sr-only">Menu de navigation / Navigation Menu</DrawerTitle>
                <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/f2s_logo.png" className="h-6" alt="Sahel Forwarding Services – F2S" />
                </Link>
                <DrawerClose asChild>
                  <Button variant="ghost" size="icon" className="text-foreground hover:bg-accent/50">
                    <X className="size-5" />
                  </Button>
                </DrawerClose>
              </DrawerHeader>
              <div className="flex-1 overflow-y-auto">
                <MenuProvider menu_id="17">
                  <MobileMenuConsumer />
                </MenuProvider>
              </div>
              <div className="p-6 border-t border-border/50">
                <p className="text-sm text-muted-foreground mb-4">Dieuppeul-Derklé rue Px4, Dakar, Sénégal</p>
                <Button className="w-full bg-primary-foreground text-primary hover:bg-primary-foreground/90 transition-colors rounded-sm font-default font-semibold" variant="outline">
                  Obtenir un Devis / Get a Quote
                </Button>
              </div>
            </DrawerContent>
          </Drawer></SafeHydrate>
        </div>

        {}
        <div className="flex-1 flex justify-center">
          <Link to="/" className="flex items-center justify-center">
            <img src="https://eternal-donkey.10web.cloud/wp-content/uploads/2026/05/logo_sahel_1_multimodal.png" className="h-28 w-auto" alt="Sahel Forwarding Services – F2S" />
          </Link>
        </div>

        {}
        <div className="flex-1 flex justify-end hidden sm:flex">
          
        </div>
      </div>
    </header>;
}